import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class planningDispatchRoutesTimelineCtrl implements IController {
  routes: any;
  tasks: any;
  suggestions: any;
  highlightTaskId: any;
  selectedSuggestionIds: any;
  suggestionsServiceAreas?: any;
  canEdit: any;
  enableSuggestions?: string;
  onTaskSelection: Function;
  onMoveItem: Function;
  onAddSuggestedServices: Function;
  onRefreshSuggestions: Function;
  onSelectSuggestion: Function;
  onToggleSuggestionsSelection: Function;
  onSuggestionsServiceAreasChange: Function;
  onRecalcRoute: Function;
  onMoveTask: Function;
  onDeleteRoute: Function;

  public timelineEnabled: boolean;
  public timelineRange: any;
  public isMouseVerticalDown: boolean;
  public leftOvers: any;
  public selectedLeftOverJobIds: any;
  public queryString: string;

  constructor(private TimelineService) {
  }


  $onInit() {
    this.timelineRange = this.TimelineService.getTimelineRange(this.routes);
    this.isMouseVerticalDown = false;
  };

  $onChanges(changes) {
    if (changes.routes && !changes.routes.isFirstChange()) {
      this.timelineRange = this.TimelineService.getTimelineRange(this.routes);
    }
  };

  isLeftOverSelected(job) {
    return _.includes(this.selectedLeftOverJobIds, job.id);
  }

  getAllDraggedLeftOverJobs(draggedJob) {
    var isDraggedSelected = this.isLeftOverSelected(draggedJob);
    return isDraggedSelected ?
      _.filter(this.leftOvers, (job) => {
          return _.includes(this.selectedLeftOverJobIds, job.id);
        }
      ) :
      [draggedJob]
  }

  onToggleTimeline() {
    this.timelineEnabled = !this.timelineEnabled;
  }

  onLeftOversScroll(scrollLeft) {
    const container = document.querySelector('div.left-overs-container');
    if (scrollLeft) {
      container.scrollLeft -= 500
    } else {
      container.scrollLeft += 500
    }
  }

  onQueryChange(query) {
    this.queryString = query;
  }
}


angular
  .module('bringoz.admin.lean-planning')
  .component('planningDispatchRoutesTimeline', {
    bindings: {
      routes: '<',
      tasks: '<',
      suggestions: '<',
      highlightTaskId: '<',
      selectedSuggestionIds: '<',
      suggestionsServiceAreas: '<?',
      canEdit: '<',
      enableSuggestions: '@?',
      onTaskSelection: '&',
      onMoveItem: '&',
      onAddSuggestedServices: '&',
      onRefreshSuggestions: '&',
      onSelectSuggestion: '&',
      onToggleSuggestionsSelection: '&',
      onSuggestionsServiceAreasChange: '&',
      onRecalcRoute: '&',
      onMoveTask: '&',
      onDeleteRoute: '&'
    },
    template: require('./planning-dispatch-routes-timeline.html').default,
    controller: planningDispatchRoutesTimelineCtrl
  });
